module.exports = __webpack_public_path__ + "images/3f549d7623aed1353bddc13895926b5d.svg";